import moment from 'moment';

const DefaultObsolescenceTimeout = 10; // minutes

export const isDataObsolete = (timestampMark: number, timeoutMinutes = DefaultObsolescenceTimeout): boolean => {
  return moment().diff(moment(timestampMark), 'minutes') >= timeoutMinutes;
};
